import { pick } from 'lodash';

export const name =
  'Вывучыце тэкст, які перад вамі. На наступным экране вам трэба будзе паўтарыць яго ўголас.';
export const nameShort = 'Вывучыце і паўтарыце тэкст';
export const bgInTable = '#1b2eef';

export const fields = [
  {
    name: 'correctAnswers',
    default: [],
    label: 'Правільныя адказы',
    component: 'ListNewValues',
  },
  {
    name: 'textContent',
    default: '',
    label: 'Змест задання',
    component: 'Input',
  },
  {
    name: 'afterTaskExplanation',
    default: '',
    label: 'Тлумачэнне задання',
    component: 'Textarea',
  },
];

export const dataToSend = form => {
  return {
    type: 'memorize_typical_answer',
    name: form.name,
    tip: form.tip,
    status: form.status,
    additionalData: {
      afterTaskExplanation: form.afterTaskExplanation,
      textContent: form.textContent,
    },
    correctAnswers: form.correctAnswers,
  };
};

export const parseData = data => {
  const dataFast = pick(data, ['name', 'status', 'tip', 'correctAnswers']);
  const { afterTaskExplanation, textContent } = data.additionalData;
  return {
    ...dataFast,
    afterTaskExplanation,
    textContent,
  };
};
